import { render, staticRenderFns } from "./AmpifireVerified.vue?vue&type=template&id=3bcfb76f&"
import script from "./AmpifireVerified.vue?vue&type=script&lang=js&"
export * from "./AmpifireVerified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports